import type { LatLng } from '@agos/shared'

import { zoneForPoint } from './zone-from-address'

/**
 * What a pin dropped on *Nová objednávka*'s map does - FRONTEND.md §9.694, the owner's #13.
 *
 * *"... a aj sa bude dať špendlíkom behať po mape a tým aj meniť adresu"*. Four rules, pure so they are
 * tests rather than things found on a till:
 *
 *   1. **the pin's own position is the order's point** - `droppedPoint`;
 *   2. **the zone follows the pin, whatever was guessed before** - `zoneAfterPin`;
 *   3. **the address text is replaced only by a real place** - `addressFromReverse`;
 *   4. **an answer for a point the builder no longer holds is dropped** - `answerStillCurrent`.
 *
 * **Rules 1, 3 and 4 live in `@agos/shared` since §9.705**, because the customer's checkout draws the same map
 * (O81) and §5 forbids one module importing another. They are re-exported here so every import in this module
 * is unchanged. Rule 2 stays: it exists because the builder stores a zone choice, and the checkout does not.
 */
export {
  addressFromReverse,
  answerStillCurrent,
  droppedPoint,
  pinStatusLine,
  type PinStatus,
} from '@agos/shared'

/**
 * An explicit *no zone* - `chosenZone` already reads `''` as none.
 *
 * **Not `null`, and the difference is the edit screen.** There the zone is `zoneId ?? loadedZoneId`, so a
 * `null` would hand the choice back to the zone the order was loaded in - and a pin dropped outside every
 * zone would go on showing the zone it was dragged out of.
 */
export const NO_ZONE = ''

/**
 * The zone the pin is in, the earlier guess ignored - §9.694.
 *
 * `zoneForPoint`, the server's rule (§9.801). The typed text will usually have guessed a zone already
 * (§9.119); a pin the operator has just moved is the most deliberate answer on the screen, so it overrides that
 * guess. Outside every zone it is `NO_ZONE`, and §9.161's manual fee appears.
 */
export function zoneAfterPin(
  point: LatLng,
  zonesPayload: unknown,
  /** §9.801 - the address in the box and the depot, which the server's tie-break reads. */
  context: { address: string; depot: LatLng | null },
): string {
  return zoneForPoint(point, zonesPayload, context) ?? NO_ZONE
}
